<div class="agent-selector">
  <h2 class="bolt-heading-md bolt-space-bottom-2xl">Start quoting</h2>
  <nwx-splash-form (formSubmit)="onSubmit($event)"></nwx-splash-form>
</div>
